import React from 'react';
import './TCOAcquisitionCostsWrapper.scss';
import { ITCOForm, ITCOSubmission } from 'types';
import { tcoDealStructureFormId } from 'utils';
import { TCOServiceComparison } from '../TCOServiceComparison';
import TCODealStructure from '../TCODealStructure';

export interface ITCOAcquisitionCostsWrapper {
  currentForms: ITCOForm[];
  /** Submission data for current form */
  tcoSubmissions: ITCOSubmission[];
}

const TCOAcquisitionCostsWrapper = ({
  currentForms,
  tcoSubmissions,
}: ITCOAcquisitionCostsWrapper) => {
  return (
    <div className="tco-wrapper">
      {currentForms.length > 0 &&
        currentForms.map((form) => {
          if (form.id === tcoDealStructureFormId) {
            return (
              <TCODealStructure
                key={form.id}
                form={form}
                tcoSubmissions={tcoSubmissions}
              />
            );
          }
          return null;
        })}

      <TCOServiceComparison
        currentForms={currentForms}
        tcoSubmissions={tcoSubmissions}
      />
    </div>
  );
};

export default TCOAcquisitionCostsWrapper;
